import { lazy, Suspense } from 'react';
import { useChrome } from '../state/chrome';

const PaletteDialog = lazy(() => import('./PaletteDialog').then((m) => ({ default: m.PaletteDialog })));

/** The command palette: every action exists without being painted. Its code loads on first open. */
export function Palette() {
  const open = useChrome((st) => st.palette);
  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <PaletteDialog />
    </Suspense>
  );
}
